module.exports = __webpack_public_path__ + "static/media/sf-trial-2-wrong.344cd9c7.mp3";